import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

import { formatSkillLabel } from '@utils';

const MAX_VISIBLE_SKILLS = 1;

export const StackCell: React.FC<{ skills: string[] | null }> = ({
  skills,
}) => {
  if (!skills?.length)
    return (
      <Typography variant="body2" color="text.lightGrey">
        n/a
      </Typography>
    );

  const visible = skills.slice(0, MAX_VISIBLE_SKILLS);
  const overflow = skills.slice(MAX_VISIBLE_SKILLS);

  return (
    <Box display="flex" gap={0.5} flexWrap="wrap" alignItems="center">
      {visible.map((skill) => (
        <Box
          key={skill}
          component="span"
          sx={(theme) => ({
            background: theme.palette.background.backgroundPrimary,
            padding: '0.125rem 0.375rem',
            borderRadius: '4px',
            textWrap: 'nowrap',
            fontSize: '0.8125rem',
          })}
        >
          {formatSkillLabel(skill)}
        </Box>
      ))}
      {Boolean(overflow.length) && (
        <Tooltip
          title={overflow.map(formatSkillLabel).join(', ')}
          placement="top"
        >
          <Typography
            component="span"
            variant="body2"
            color="text.secondary"
            px={0.5}
            flexShrink={0}
          >
            +{overflow.length}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
};
